import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { ArrowLeft, Book, Video, MessageCircle } from "lucide-react";
import Footer from "../components/Footer";

export default function HelpCenter() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="border-b border-gray-200 bg-white px-6 py-4 shadow-sm">
        <div className="max-w-6xl mx-auto flex items-center gap-6">
          <div className="logo-placeholder"></div>
          <Button variant="ghost" onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Studio
          </Button>
        </div>
      </header>

      <div className="flex-1 p-6 bg-gray-50">
        <div className="max-w-6xl mx-auto space-y-6">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Help Center</h1>
            <p className="text-gray-600">Find answers and get support</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Card className="bg-white border-gray-200 shadow-md p-6 text-center">
              <Book className="w-12 h-12 mx-auto mb-4 text-blue-600" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Documentation</h3>
              <p className="text-sm text-gray-600 mb-4">Comprehensive guides and tutorials</p>
              <div className="bg-blue-50 border border-blue-200 rounded p-3 text-xs text-blue-900">
                Content placeholder: Add your documentation links
              </div>
            </Card>

            <Card className="bg-white border-gray-200 shadow-md p-6 text-center">
              <Video className="w-12 h-12 mx-auto mb-4 text-green-600" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Video Tutorials</h3>
              <p className="text-sm text-gray-600 mb-4">Step-by-step video guides</p>
              <div className="bg-blue-50 border border-blue-200 rounded p-3 text-xs text-blue-900">
                Content placeholder: Add your video tutorial links
              </div>
            </Card>

            <Card className="bg-white border-gray-200 shadow-md p-6 text-center">
              <MessageCircle className="w-12 h-12 mx-auto mb-4 text-purple-600" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Contact Support</h3>
              <p className="text-sm text-gray-600 mb-4">Get help from our team</p>
              <div className="bg-blue-50 border border-blue-200 rounded p-3 text-xs text-blue-900">
                Content placeholder: Add contact form or support email
              </div>
            </Card>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
